export const DOMAIN_CURRENCIES = "CURRENCIES";
